import { render, staticRenderFns } from "./SideBarDigitalPrint.vue?vue&type=template&id=2e8ce008"
import script from "./SideBarDigitalPrint.vue?vue&type=script&lang=js"
export * from "./SideBarDigitalPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports